import React, { Dispatch, SetStateAction } from 'react'
import { ResetPasswordTokenContainer } from '~/components'

type RecoverPasswordFormProps = {
  onPasswordRecoverySuccess: Dispatch<SetStateAction<boolean>>,
  redirectToLogin: () => void
};

export const RecoverPasswordForm: React.FC<RecoverPasswordFormProps> = ({
  onPasswordRecoverySuccess,
  redirectToLogin
}) => {
  return (
    <ResetPasswordTokenContainer
      title='Esqueci minha senha'
      description='Esqueceu sua senha? Sem problemas! Informe o CNPJ da sua empresa para receber um link por email e cadastrar uma nova senha.'
      onBackButtonClick={redirectToLogin}
      setSuccessfulOperation={onPasswordRecoverySuccess}
    />
  )
}
